// Per-table "high water mark" for the pull pass. We persist the latest
// server `updated_at` we've seen so subsequent pulls only fetch deltas. The
// cursor is keyed in localStorage by table so a multi-account device (rare
// today, but plausible if we ever support account switching) doesn't bleed
// state — we'll add `:<userId>` if/when that lands.

import type { SyncTableName } from './types';

const KEY_PREFIX = 'bycm:syncCursor:';

export function readCursor(table: SyncTableName): string | null {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem(`${KEY_PREFIX}${table}`);
}

export function writeCursor(table: SyncTableName, isoTimestamp: string): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(`${KEY_PREFIX}${table}`, isoTimestamp);
  } catch {
    // Quota / private-mode failures aren't fatal — next sync just refetches.
  }
}

export function clearCursor(table: SyncTableName): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem(`${KEY_PREFIX}${table}`);
}

// The Supabase query uses `.gt(updated_at, since)` which expects ISO. When
// we have no cursor, fall back to the epoch so the first sync pulls
// everything the user owns.
export function cursorOrEpoch(table: SyncTableName): string {
  return readCursor(table) ?? new Date(0).toISOString();
}
